<div class="bg-white min-h-screen">
    <!-- Hero Section -->
    <div class="bg-app-background-20 py-16 border-b border-gray-200">
        <div class="max-w-4xl mx-auto px-6">
            <h1 class="text-4xl font-fraunce text-app-primary-20 mb-4">Über Uns</h1>
            <p class="text-app-secondary-10 text-xl">Die Mission von Patriacura: Medizinische Versorgung digital und menschlich.</p>
        </div>
    </div>

    <!-- Content -->
    <div class="max-w-4xl mx-auto px-6 py-16">
        <div class="grid grid-cols-1 md:grid-cols-2 gap-16 items-center">
            <div class="space-y-6">
                <h2 class="text-3xl font-fraunce text-app-primary-20">Wer wir sind</h2>
                <p class="text-app-secondary-10 leading-relaxed">
                    Patriacura ist eine Marke der Aliacura e.K. und steht für eine moderne, digitale Gesundheitsversorgung. Wir glauben daran, dass der Zugang zu ärztlicher Beratung unkompliziert, sicher und zeitgemäß sein sollte.
                </p>
                <p class="text-app-secondary-10 leading-relaxed">
                    Unser Team aus IT-Experten und medizinischen Fachkräften arbeitet täglich daran, die Brücke zwischen Patienten, Ärzten und Apotheken zu stärken.
                </p>
            </div>
            <div class="bg-app-background-20 aspect-square rounded-2xl flex items-center justify-center p-12">
                <img src="assets/logo/logo.svg" alt="Patriacura Logo" class="w-full opacity-50">
            </div>
        </div>

        <div class="mt-24 grid grid-cols-1 sm:grid-cols-3 gap-8">
            <div class="text-center p-6 space-y-3">
                <div class="text-3xl text-app-primary-10"><i class="fa-solid fa-shield-halved"></i></div>
                <h3 class="text-xl font-bold text-app-primary-20">Sicherheit</h3>
                <p class="text-sm text-app-secondary-10">Höchste Standards beim Datenschutz und verschlüsselte Kommunikation.</p>
            </div>
            <div class="text-center p-6 space-y-3">
                <div class="text-3xl text-app-primary-10"><i class="fa-solid fa-users"></i></div>
                <h3 class="text-xl font-bold text-app-primary-20">Menschlichkeit</h3>
                <p class="text-sm text-app-secondary-10">Trotz Digitalisierung steht das persönliche Arztgespräch im Fokus.</p>
            </div>
            <div class="text-center p-6 space-y-3">
                <div class="text-3xl text-app-primary-10"><i class="fa-solid fa-bolt"></i></div>
                <h3 class="text-xl font-bold text-app-primary-20">Effizienz</h3>
                <p class="text-sm text-app-secondary-10">Schnelle Termine und digitale Rezepte sparen Ihnen wertvolle Zeit.</p>
            </div>
        </div>
    </div>
</div>
